import { render } from "./RibbonLinkText.vue?vue&type=template&id=4ae2d17b"
import script from "./RibbonLinkText.vue?vue&type=script&lang=js"
export * from "./RibbonLinkText.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.17.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__